import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardPage.vue?vue&type=style&index=0&id=8940a788&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8940a788"]])

export default __exports__